import { render, staticRenderFns } from "./DespesaChart.vue?vue&type=template&id=50f1ee21"
import script from "./DespesaChart.vue?vue&type=script&lang=js"
export * from "./DespesaChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports